<template>
  <v-btn
    class="mt-3 text-capitalize white--text mapGradient"
    @click="openMap()"
  >
    <icon name="icon-map" height="20" width="23" class="mr-2"></icon>
    <translate>See the map</translate>
  </v-btn>
</template>
<script>
export default {
  name: "ButtonGoogleMap",
  props: {
    countryCode: {
      type: Object,
      default:() => {}
    },
    slugCourse: {
      type: String,
      default: '',
    },
    googleUrl: {
      type: String,
      default: ''
    }
  },
  data: () => ({}),
  computed: {},
  methods: {
    async openMap() {
      await this.$store.state.toggle.dialogGoogleMap.open(this.countryCode, this.slugCourse, this.googleUrl)
    }
  },
};
</script>
<style lang="scss">
  .mapGradient {
    background: linear-gradient(180deg, #179D4E 0%, #025424 100%);
  }
</style>